import React from 'react';
import {useState, useEffect, useLayoutEffect} from 'react';

import './App.css';
import './output.css';

const Blank = () => {
  const [changeClass, setChangeClass] = useState(false);

  setTimeout(() => {
    setChangeClass(true);
  }, 100);

  return(
    <div style={{height:'calc(100lvh - 4rem)', minWidth:'30rem'}} className="z-10 w-full bg-amber-50 text-center place-content-center grid">
    </div> 
  )
};

export default Blank;